import { Link } from '@tanstack/react-router'
import { clsx } from 'clsx'
import { useAdminGameweeks, type AdminGameweek, type GameweekStatus } from '../queries'
import styles from './GameweekTable.module.css'

type GameweekTableProps = {
  competitionId: string | null
}

const STATUS_LABEL: Record<GameweekStatus, string> = {
  UPCOMING:  'Aguardando',
  ACTIVE:    'Ativa',
  LOCKED:    'Bloqueada',
  FINALIZED: 'Finalizada',
}

export function GameweekTable({ competitionId }: GameweekTableProps) {
  const { data, isPending, isError } = useAdminGameweeks(competitionId)

  if (!competitionId) {
    return <div className={styles.empty}>Selecione uma competição para ver as rodadas.</div>
  }
  if (isPending) return <div className={styles.empty}>Carregando rodadas…</div>
  if (isError || !data) return <div className={styles.empty}>Erro ao carregar rodadas.</div>
  if (data.length === 0) return <div className={styles.empty}>Nenhuma rodada cadastrada para esta competição.</div>

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.colNum}>GW</th>
          <th className={styles.colPhase}>Fase</th>
          <th className={styles.colStatus}>Status</th>
          <th className={styles.colDate}>Primeiro jogo</th>
          <th className={styles.colAction} />
        </tr>
      </thead>
      <tbody>
        {data.map((gw) => (
          <GameweekRow key={gw.id} gw={gw} />
        ))}
      </tbody>
    </table>
  )
}

function GameweekRow({ gw }: { gw: AdminGameweek }) {
  return (
    <tr>
      <td className={styles.num}>GW{gw.number}</td>
      <td className={styles.phase}>{gw.phase}</td>
      <td>
        <span className={clsx(styles.badge, styles[`badge_${gw.status}`])}>
          {STATUS_LABEL[gw.status] ?? gw.status}
        </span>
      </td>
      <td className={styles.date}>{formatDate(gw.firstMatchAt)}</td>
      <td className={styles.actionCell}>
        <Link
          to="/admin/gameweek/$gameweekId"
          params={{ gameweekId: gw.id }}
          className={styles.actionLink}
        >
          Abrir →
        </Link>
      </td>
    </tr>
  )
}

function formatDate(iso: string): string {
  const d = new Date(iso)
  return d.toLocaleString('pt-BR', {
    day:    '2-digit',
    month:  '2-digit',
    year:   '2-digit',
    hour:   '2-digit',
    minute: '2-digit',
  })
}
